export default "__VITE_ASSET__081c0e86__"